import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"arrow-right\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24.47 25.97a.75.75 0 1 0 1.06 1.06l5.793-5.793a1.75 1.75 0 0 0 0-2.474L25.53 12.97a.75.75 0 1 0-1.06 1.06l5.22 5.22H9a.75.75 0 0 0 0 1.5h20.69l-5.22 5.22Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol